// extracted by mini-css-extract-plugin
export default {"square-below-name":"wIgKYGP7ff_B_gaSSbRe","type-default":"zowKH4FlSp1Sbe4zS5zq","type-small":"GQZ3f6z4_nT_EVTT0UK0","common_bganimation":"FOZi4tm6ou94KnZSTSq_"};